import ListingDetail from "../components/Listings/ListingDetail";

export default ListingDetail;
